import React, { useState, useEffect } from "react";
import "./anotattionsCss.css";
import { ChartAnnotation } from "./lineChart";
const uniqueKey = require("unique-key");

interface AnnotationLegendProps {
  legendItems: ChartAnnotation[];
  labelOrder: string[];
  label?: string;
  onVisibilityChange: (visibleAnnotations: { [key: string]: boolean }) => void;
}

const AnnotationLegend: React.FC<AnnotationLegendProps> = ({
  legendItems,
  labelOrder,
  onVisibilityChange,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const initialState = legendItems.reduce((acc, item) => {
      acc[item.value] = isVisible;
      return acc;
    }, {} as { [key: string]: boolean });
    onVisibilityChange(initialState);
  }, [legendItems, isVisible]);

  const toggleAllVisibility = () => {
    setIsVisible(!isVisible);
  };

  const sortedLegendItems = [...legendItems].sort((a, b) => {
    const indexA = labelOrder.indexOf(a.value);
    const indexB = labelOrder.indexOf(b.value);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    return 0;
  });

  return (
    <div className="anot-hold flex flex-col h-64 overflow-y-scroll space-y-1 ml-5 mt-20">
      {sortedLegendItems?.length > 0 ? (
        <>
          {/* <div className="flex items-center justify-between space-x-2 mb-4 px-2">
            <span className="text-white text-sm">{isVisible ? 'Hide' : 'Show'} Holidays</span>
            <button
              onClick={toggleAllVisibility}
              className={`relative w-12 h-6 rounded-full transition-colors duration-300 focus:outline-none ${
                isVisible ? 'bg-blue-600' : 'bg-gray-600'
              }`}
            >
              <span
                className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 transform ${
                  isVisible ? 'translate-x-6' : 'translate-x-0'
                }`}
              />
            </button>
          </div> */}
          {sortedLegendItems?.map((holidayName) => (
          <div
            key={uniqueKey("annotation_legends")}
            className="flex items-center space-x-2"
          >
            <span
              className="w-2.5 h-1"
              style={{ backgroundColor: holidayName.label.backgroundColor }}
            ></span>
            <span className="text-white text-sm w-full">
              {`${holidayName.value}: `}
              {holidayName.label.content.replace(/\s*\(.*?\)$/, "")}
            </span>
          </div>
          ))}
        </>
      ) : (
        <p className="pt-20">No holidays received/found!</p>
      )}
    </div>
  );
};

export default AnnotationLegend;
